<template>
  <div class="wechat-moments-list">
    <CommonSOP :KHSOPxbc="KHSOPxbc" :KHSOPcd="QFcd" namePlaceholder="消息名称" :tableData="tableData" :tableHeader="tableHeader" @reGet="getData" @createSOP="createSOP"  @handleDetail="handleDetail" @handleData="handleData" :pageparm="pageparm"></CommonSOP>
    <CommonSOPDetail titleName="新建群发" :myType="5" @reGet="getData" :myVisiable="myVisiable" @closeDialog="closeDialog"></CommonSOPDetail>
    <DataDialog :isLoading="isLoading" :KHSOPcd="QFcd" :titleName="titleName"  :tableHeader="dataTableHeader" :tableData="dataTableData" @closeDialog="dataCloseDialog" :myVisiable="dataMyVisiable" :pageparm="dataPageparm" :myType="3" @reGet="reGet"  @handleExport="handleExport"/>
    <SopDetail titleName="群发详情" :myType="5" :myVisiable="detailMyVisiable" :detaildata="detailData"  @closeDialog="closeDetailDialog"/>
  </div>
  
 </template>
 <script>
 import CommonSOPDetail from '@/views/mass/SOP/components/commonSOPDetail.vue'
 import CommonSOP from '@/views/mass/SOP/components/commonSOP.vue'
 import DataDialog from '@/views/mass/SOP/components/dataDialog.vue'
 import SopDetail from '@/views/mass/SOP/components/sopDetail.vue'
 import { getMsgSendList,getMsgSendEmp ,getMsgSendDetail } from "@/api/sop/sop.js"
 export default {
  name: "wechatMomentsSOP",
  components: {
    CommonSOP,
    CommonSOPDetail,
    DataDialog,
    SopDetail
  },
  data() {
    return {
      myVisiable: false,
      searchSelectTime: '',
      dataMyVisiable: false,
      titleName: '',      // 数据的弹框标题
      dataTableHeader: [
        {
          id: 'userName',
          label: '执行员工',
          minWidth: 100,
          align: 'center'
        },
        {
          id: 'situation',
          label: '已完成',
          minWidth: 100,
          align: 'center'
        },
        {
          id: 'sendTime',
          label: '完成时间',
          minWidth: 120,
          align: 'center'
        }
      ],
      detailData: {},
      detailMyVisiable: false,

      getDataListParams: {
        taskId: '',   
        mark: -1, // 是否完成【int】0：否  1：完成
        pageNum: 1, // 页码，不传默认为1
        pageSize: 10,  //页数，不传默认为10
      },
      dataPageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      isLoading: false,
      dataTableData: [],
      tableHeader: [
        {
          id: 'msgName',
          label: '消息名称',
          minWidth: 120,
          align: 'left'
        },
        {
          id: 'content',
          label: '发送内容',
          minWidth: 120,
          align: 'center'
        },
        {
          id: 'empNum',
          label: '应完成员工数',
          minWidth: 70,
          align: 'center'
        },
        {
          id: 'empNumDone',
          label: '已完成员工数',
          minWidth: 70,
          align: 'center'
        },
        {
          id: 'empNumNoDone',
          label: '未完成员工数',
          minWidth: 70,
          align: 'center'
        },
        {
          id: 'createMessage',
          label: '创建信息',
          minWidth: 150,
          align: 'center'
        },
        {
          id: 'option',
          label: '操作',
          minWidth: 120,
          align: 'center'
        },
      ],
      getDataParams: {
        msgName: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      taskId: '',
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200,500], //分页条数
      KHSOPxbc: false,      // 可新建
      QFcd: false,          // 可查看/导出数据 
      timer: null,          // 是否需要定时请求列表
    };
  },
  created() {
    console.log('sssss',JSON.parse(JSON.stringify(this.getDataParams)))
    this.getData(this.getDataParams)
  },
  watch: {
    btnAuthority: {
      handler(newVal,oldVal) {
        if(newVal.length > 0) {
          newVal.forEach(item => {
            if(item.pname == '客户群发') {
              let senBtnAuthority = item.cfunBu
              if(senBtnAuthority.indexOf('kxj') != -1) {
                // 可新建群发
                this.KHSOPxbc = true
              }else {
                this.KHSOPxbc = false
              }
              if(senBtnAuthority.indexOf('QFcd') != -1) {
                this.QFcd = true
              }else {
                this.QFcd = false
              }
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority
    }
  },
  destroyed() {
    if(this.timer != null) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    closeDetailDialog() {
      this.detailMyVisiable = false
    },
    closeDialog(val) {
      this.myVisiable = val
    },
    dataCloseDialog(val) {
      this.dataMyVisiable = val
    },
    // 获取列表数据
    getData(params) {
      let that =this
      if(params == 'createNew') {
        params = this.getDataParams
        params.pageNum = 1
        params.pageSize = this.pageparm.pageSize
      }else{
        this.getDataParams.msgName = params.sopName?params.sopName:''
        this.getDataParams.startTime = params.startTime
        this.getDataParams.endTime = params.endTime
        this.getDataParams.pageNum = params.pageNum
        this.getDataParams.pageSize = params.pageSize
      }
      this.pageparm.currentPage = params.pageNum
      this.pageparm.pageSize = params.pageSize
      getMsgSendList(this.getDataParams,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          this.tableData = res.data.result
          this.pageparm.total = res.data.total
          if(this.timer!=null){
            clearTimeout(that.timer)
          }
          //判断是否有生成中的数据
          for (let i = 0; i < this.tableData.length; i++) {
            if(this.tableData[i].status == 1){
              //如果有生成中的数据则创建一个5s延时
              this.timer = setTimeout(()=>{this.getRefresh(this.getDataParams)}, 5000);
              break
            }
          }
        }
      })
    },
    // 获取群发数据列表 --刷新
    getRefresh(params) {
      let that = this;
      getMsgSendList(params,localStorage.getItem("Authorization"),true).then(res => {
        if(res.error.code == 200){
          if(that.tiemer) {
            clearTimeout(that.timer)
          }
          let tempArr = []//标记数据的状态
          //暂存结果数组
          let resultArr = res.data.result;
            //列表处于生成中的数据(未生成成功的数据)
          let creatArr = that.tableData.filter(v=>{
            if(v.status == 1){
              tempArr.push(1)
            }
            return v.status == 1
          })
          creatArr.map((v,index)=>{
            for (let i = 0; i < resultArr.length; i++) {
              if(v.id == resultArr[i].id){
                //已经生成成功
                if(resultArr[i].status == 0){
                  tempArr[index] = 0
                  //替换数据
                  let str = JSON.parse(JSON.stringify( that.tableData))
                  for (let j = 0; j < str.length; j++) {
                    if(v.id == str[j].id){
                      str[j] = resultArr[i]
                      that.tableData = str;
                      break
                    }
                  }
                }
                break
              }
            }
          })
          //如果还有生成中的数据
          if(tempArr.indexOf(1) != -1){
            that.timer = setTimeout(()=>{that.getRefresh(params)}, 5000);
          }
        }
      }).catch(err => {
        console.log(err,'errr')
      })
    },

    // 新建sop
    createSOP() {
      this.myVisiable = true
      console.log('新建')
    },
    // 导出
    handleExport() {
      this.download('/api/msgSend/exportDataMsgSend/'+this.taskId, `群发完成情况_${new Date().getTime()}.xlsx`,{
      },localStorage.getItem("Authorization"),1,'get')
    },
    // 点击详情按钮
    handleDetail(sopId,row) {
      getMsgSendDetail(row.id,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          console.log('res.data',JSON.parse(JSON.stringify(res.data)))
          console.log('this.detailData',JSON.parse(JSON.stringify(this.detailData)))
          this.detailData = res.data
          this.detailMyVisiable = true
        }
      })
      
      console.log('详情')
    },
    // 点击数据按钮
    handleData(sopId,name,row) {
      if(row.status == 1) {
        this.$message({
          message:'数据处理中，请稍后!',
          type: 'info',
          offset: 30,
          duration: 1500,
          customClass: 'info-message'
        });
      }else {
        this.taskId = row.id
        this.titleName = row.msgName
        this.getDataListParams.pageNum = 1
        this.getDataListParams.pageSize = 10
        this.getDataListParams.mark = -1
        this.getDataListParams.taskId = row.id
        this.getDataList()
        console.log('数据')
      }
      
    },
    getDataList() {
      this.isLoading = true
      if(!this.dataMyVisiable) {
        this.dataMyVisiable = true
      }
      getMsgSendEmp(this.getDataListParams,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          this.dataTableData = res.data.result
          this.dataPageparm.total = res.data.total
          this.isLoading = false
        }else {
          this.isLoading = false
          this.$message.error('获取数据失败，请重试！')
        }
      })
    },
    // flag为true时 mark
    reGet(parm,mark) {
      if(mark != undefined) {
        this.getDataListParams.pageNum = 1
        this.getDataListParams.mark = mark
      }else {
        this.getDataListParams.pageNum = parm.currentPage
        this.getDataListParams.pageSize = parm.pageSize
      }
      this.getDataList()
    }
  }
};
 </script>
 <style lang="scss" scoped>
 .wechat-moments-list {
   height: 100%;
   width: 100%;
 }
 </style>